'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _hudlVideoInterface = require('hudl-video-interface');

var _communityContentUtil = require('../../../utils/community-content-util');

var _communityContentUtil2 = _interopRequireDefault(_communityContentUtil);

var _actionCreators = require('../../../store/actions/action-creators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var play = _hudlVideoInterface.viActions.play,
    setAutoAdvance = _hudlVideoInterface.viActions.setAutoAdvance,
    setCurrentTimeMs = _hudlVideoInterface.viActions.setCurrentTimeMs,
    setPlayingIndex = _hudlVideoInterface.viActions.setPlayingIndex;


function getCommunityId(communityContentId) {
  var type = communityContentId.type,
      relatedId = communityContentId.relatedId,
      secondaryRelatedId = communityContentId.secondaryRelatedId;

  return _communityContentUtil2.default.buildCommunityContentId(type, relatedId, secondaryRelatedId);
}

// exported for testing only
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var player = state.players && state.players[ownProps.playerId] || {};
  var playables = player.playables && player.playables.size ? player.playables.toJS() : ownProps.playables;
  var communityContentId = playables[player.playingIndex || 0].communityContentId;
  var serializedId = getCommunityId(communityContentId);

  var playingContent = state.communityContent.playing[serializedId] || {};
  var startTimeMs = playingContent.positionMs;

  // If this content has play tracking pixels that signals this content is sponsored and we should
  // no preroll ads on sponsored content.
  var tracking = state.communityContent.tracking[communityContentId.type + '-' + communityContentId.relatedId] || {};
  var adTag = tracking.onPlayTrackingPixels && tracking.onPlayTrackingPixels.length ? null : ownProps.adTag;
  var headerBid = state.communityContent.ads.headerBid;
  var triedFetchHeaderBid = state.communityContent.ads.triedFetchHeaderBid;

  return {
    player: player,
    playables: playables,
    startTimeMs: startTimeMs,
    adTag: adTag,
    headerBid: headerBid,
    triedFetchHeaderBid: triedFetchHeaderBid
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    play: play,
    setAutoAdvance: setAutoAdvance,
    setCurrentTimeMs: setCurrentTimeMs,
    setPlayingIndex: setPlayingIndex,
    fetchHeaderBid: _actionCreators.fetchHeaderBid
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);